// Per-division colour theming. Keeps the app's overall branding but lets each
// division carry a subtle accent (headers, buttons, tints). Default = brand blue.
export const DIVISION_COLORS = [
  { key: "blue", label: "Blue", hex: "#1E63C4" },
  { key: "red", label: "Red", hex: "#E11D2A" },
  { key: "silver", label: "Silver", hex: "#6B7280" },
  { key: "green", label: "Green", hex: "#1E9E6A" },
  { key: "amber", label: "Amber", hex: "#D97706" },
  { key: "purple", label: "Purple", hex: "#7C3AED" },
  { key: "teal", label: "Teal", hex: "#0D9488" },
  { key: "orange", label: "Orange", hex: "#EA580C" },
];

const hexToRgb = (hex) => {
  const h = hex.replace("#", "");
  const full = h.length === 3 ? h.split("").map((c) => c + c).join("") : h;
  const n = parseInt(full, 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
};

export const divisionTheme = (color) => {
  const found = DIVISION_COLORS.find((c) => c.key === color) || DIVISION_COLORS[0];
  const [r, g, b] = hexToRgb(found.hex);
  return {
    key: found.key,
    hex: found.hex,
    label: found.label,
    vars: {
      "--div-accent": found.hex,
      "--div-tint": `rgba(${r},${g},${b},0.10)`,
      "--div-border": `rgba(${r},${g},${b},0.35)`,
    },
  };
};
